import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const CompanyRootElement = styled.div`
    width: 100%;
    .story-section {
        padding-top: ${styleVariables.primitivesFontSizeFallbacks['6']};
        padding-bottom: ${styleVariables.primitivesFontSizeFallbacks['9']};
        background: linear-gradient(180deg, #fff 0%, #fbfbfb 100%);
        .MuiTypography-headline-large {
            display: block;
        }
        @media (max-width: 767px) {
            padding-bottom: ${styleVariables.primitivesFontSizeFallbacks['6']};
            .MuiTypography-headline-large {
                margin-bottom: 18px;
                font-size: 28px;
            }
        }
        ol,
        ul {
            margin-top: 20px;
            list-style-position: outside;
            padding-left: 18px;
            li {
                margin-bottom: 15px;
            }
        }
    }
    .story-section-top {
        padding-top: 64px;
        padding-bottom: 44px;
        background: linear-gradient(180deg, #fff 0%, #fbfbfb 100%);
        .MuiTypography-headline-large {
            display: block;
        }
        @media (max-width: 767px) {
            padding-top: 36px;
            padding-bottom: 24px;
            .MuiTypography-headline-larger {
                font-size: 32px;
            }
        }
        .default-card-image {
            margin-top: 78px;
            @media (max-width: 767px) {
                margin-top: 42px;
            }
        }
    }
    .story-page-container {
        max-width: 864px;
        margin: 0 auto;
        padding: 0px 1em;
    }
`;
export default CompanyRootElement;
